<div class="icon-box icon-box--{{ color }} icon-box--size-{{ size }} {{ sizeSm ? 'icon-box--size-sm-' + sizeSm : '' }} {{ rounded ? 'icon-box--rounded' : '' }}">
  @if (icon) {
    <app-icon [icon]="icon" [fit]="true" [width]="20" [height]="20"></app-icon>
  } @else {
    <ng-content></ng-content>
  }
</div>
